// FEAT-025 — AdminUserList 의 RayTable row builder (순수 함수).
//
// PR #185 R1 Blocker 회귀 방어: 매 렌더마다 호출되어도 Redux store 의 user 객체를
// mutate 하지 않고 새 row 객체를 반환하도록 보장. 단위 테스트로 invariant 고정.
//
// 입력: users 배열 + 의존성 (translate fn, function code → label map)
// 출력: RayTable 이 표시할 row 객체 배열 (mutation 없음, idempotent)

import { normalizeUserDealerType } from './userNormalize';

const buildFunctionLabelMap = (adminFunctions) => {
    const map = {};
    (adminFunctions || []).forEach((f) => { map[f.code] = f.title; });
    return map;
};

export const buildAdminUserListRow = (rawUser, { t, fnLabelMap }) => {
    const normalized = normalizeUserDealerType(rawUser);
    return {
        ...normalized,
        setname: `${normalized.firstName ?? ''} ${normalized.lastName ?? ''}`.trim(),
        companyName: normalized.companyInfo?.name,
        country: normalized.companyInfo?.country,
        function: fnLabelMap[normalized.function] ?? normalized.function,
        isEmail: normalized.isEmail === undefined ? true : normalized.isEmail,
        // IMP-109 AC-2/3 — isTypeChange=true 인 딜러 계정만 Dealer Type 표시.
        // Subsidiary/HQ 는 isTypeChange 가 false/undefined 이므로 '—' 처리.
        dealerType: normalized.isTypeChange
            ? (normalized.dealerType === 'external' ? t('license.label.externalDealer') : t('license.label.internalDealer'))
            : '—',
    };
};

export const buildAdminUserListRows = (users, { t, adminFunctions }) => {
    if (!Array.isArray(users)) return [];
    const fnLabelMap = buildFunctionLabelMap(adminFunctions);
    return users.map((u) => buildAdminUserListRow(u, { t, fnLabelMap }));
};
